import { InventoryTransactionLineUnitListPage } from "@/features/inventory-transaction-line-unit/pages/InventoryTransactionLineUnitListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inventory-transaction-line-unit/")(
	{
		beforeLoad({ context }) {
			if (
				!context.authAdapter.can({
					permissions: ["inventory_transaction_line_unit.view"],
				})
			) {
				throw redirect({ to: "/403" });
			}
		},
		component: InventoryTransactionLineUnitListPage,
	},
);
